import { render } from "./ShowMakerChecker.vue?vue&type=template&id=70f20a3e"
import script from "./ShowMakerChecker.vue?vue&type=script&lang=js"
export * from "./ShowMakerChecker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__